import './TabLabelWithBadge.css';
import type { ReportSeverity } from '@ipfabric/utils';
import classNames from 'classnames';
import type { FC } from 'react';

interface ReportSeverityBadge {
  count: number;
  severity: ReportSeverity;
}

interface Props {
  badge?: ReportSeverityBadge;
  className?: string;
  loading?: boolean;
  text: string;
}

export const TabLabelWithReportSeverityBadge: FC<Props> = (props) => (
  <div className={classNames('tab-label-with-badge', props.className)}>
    <div>{props.text}</div>
    {props.loading ? (
      <i className='fa-regular fa-spin fa-spinner' />
    ) : (
      <div
        className={classNames(
          props.badge?.severity === 0 &&
            'tab-label-with-badge__badge--severity-0',
          props.badge?.severity === 10 &&
            'tab-label-with-badge__badge--severity-10',
          props.badge?.severity === 20 &&
            'tab-label-with-badge__badge--severity-20',
          props.badge?.severity === 30 &&
            'tab-label-with-badge__badge--severity-30',
          !props.badge && 'tab-label-with-badge__badge--na',
          'badge',
        )}
      >
        {props.badge?.count ?? 'N/A'}
      </div>
    )}
  </div>
);
